import { generatePath, useHistory, useLocation } from "react-router-dom";
import { IPayeeTaxFormResponse } from "@wingspanhq/payments/dist/interfaces";
import { OLD_TAX_DOCUMENTS_PATH } from "../TaxDocumentsOld/paths";
import { getCurrentTaxDocumentsYear } from "./utils/getCurrentTaxDocumentsYear";

export const TAX_DOCUMENTS_ROOT_PATH = "/member/tax-documents";

export const TAX_DOCUMENTS_PATH = TAX_DOCUMENTS_ROOT_PATH + "/:year";
export const TAX_DOCUMENTS_DETAILS_PATH =
  TAX_DOCUMENTS_PATH + "/:taxFormId/:submissionId";
export const TAX_DOCUMENTS_REQUEST_CORRECTION_PATH =
  TAX_DOCUMENTS_DETAILS_PATH + "/request-correction";

export const getTaxDocumentsPathWithYear = (path: string) => {
  return generatePath(path, {
    year: getCurrentTaxDocumentsYear()
  });
};

const useGoToTaxDocumentSubPath = (path: string) => {
  const history = useHistory();

  return (taxFormId: string, submissionId: string) => {
    const url = generatePath(path, {
      taxFormId,
      submissionId,
      year: getCurrentTaxDocumentsYear()
    });

    history.push(url);
  };
};

export const useGoToTaxDocumentByIds = () =>
  useGoToTaxDocumentSubPath(TAX_DOCUMENTS_DETAILS_PATH);

export const useGoToTaxDocumentByTaxForm = () => {
  const redirect = useGoToTaxDocumentSubPath(TAX_DOCUMENTS_DETAILS_PATH);

  return (taxForm: IPayeeTaxFormResponse) => {
    const submission = taxForm.submissions?.[0];

    redirect(
      taxForm.taxFormId,
      taxForm.currentSubmissionId || submission?.taxFormSubmissionId || ""
    );
  };
};

export const useGoToRequestCorrection = () =>
  useGoToTaxDocumentSubPath(TAX_DOCUMENTS_REQUEST_CORRECTION_PATH);

export const useGoToTaxDocumentsDashboard = () => {
  const history = useHistory();
  const location = useLocation();

  return () => {
    if (location.pathname.startsWith(OLD_TAX_DOCUMENTS_PATH)) {
      history.push(OLD_TAX_DOCUMENTS_PATH);
    } else {
      history.push(
        generatePath(TAX_DOCUMENTS_PATH, { year: getCurrentTaxDocumentsYear() })
      );
    }
  };
};
